import React from 'react';
import DOMPurify from 'dompurify';

type SafeHtmlRendererProps = React.HTMLAttributes<HTMLDivElement> & {
  html: string | null | undefined;
  forceBody?: boolean;
};

export const SafeHtmlRenderer = React.forwardRef<
  HTMLDivElement,
  SafeHtmlRendererProps
>(({ html, forceBody, ...divProps }, ref) => {
  // Pre-strip comments so DOMPurify's mXSS heuristic doesn't drop Trix blocks containing `<` next to a word char (e.g. `<50%`).
  const htmlWithoutComments = (html ?? '').replace(/<!--[\s\S]*?-->/g, '');
  const sanitizedHtml = DOMPurify.sanitize(htmlWithoutComments, {
    FORCE_BODY: forceBody,
  });

  return (
    <div
      {...divProps}
      ref={ref}
      // We just sanitized it and didn't pass it anywhere else, so it's safe to render.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
});
